import { api_config } from '../../../api-commons';
import { IDeviceSiteService } from './IDeviceSiteService';

class DeviceSiteService implements IDeviceSiteService {
  async unassign(id: number, params: string): Promise<string> {
    const response = await api_config.put(
      `/device_sites/${id}/end_assignement?end_date=${params}`
    );
    return response.data;
  }
}

const instance = new DeviceSiteService();
export default instance;
